import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "../../../View.css";
import "../../../Grid.css";
import "../../../Form.css";
import "../../../App.css";
import "./Assessor.css";
import { ViewContainer } from "../../../View.jsx";
import ViewUtils from '../../../ViewUtils';
import LinkDialog from "../../LinkDialog";
import withMenuPermission from "../../../widgets/withMenuPermission";
import EnhancedTable from '../../../widgets/ResponsiveTable';
import EnhancedToolbar from '../../../widgets/Toolbar';
//IMPORT NEW UNIT STANDARD TABLE POPUP COMPONENT 
import OnlineAssessorScopeUS from './OnlineAssessorScopeUS';

const linkToolbarRef = React.createRef();
const utils = new ViewUtils();

const topToolbarConfig = {
    items: [
        {
            type: "buttonGroup",
            buttons: [
                { id: 'viewScopeUS', label: '', tooltip: 'View unit standards linked to qualification', icon: 'ViewIcon', disabled: true }
            ]
        }
    ]
};

const lowertoolbarConfig = {
    items: [
        {
            type: "buttonGroup",
            buttons: [
                { id: 'back', label: 'BACK', tooltip: 'Back to learnership scope', theme: true },
                { id: 'next', label: 'NEXT', tooltip: 'Proceed to unit standard scope', theme: true }
            ]
        }
    ]
};

const headCells = [
    { id: 'SAQAQualificationID', numeric: false, disablePadding: true, label: 'Qualification Code' },
    { id: 'SAQAQualificationTitle', numeric: false, disablePadding: true, label: 'Qualification Title' },
    { id: 'Credits', numeric: false, disablePadding: true, label: 'Credits' },
    { id: 'QualificationRegistrationStartDate', numeric: false, disablePadding: true, label: 'Registration Start Date' },
    { id: 'QualificationRegistrationEndDate', numeric: false, disablePadding: true, label: 'Registration End Date' }
];

class OnlineAssessorApprovalQualificationScope extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchParameters: [{ Name: `OnlineAssessorAppID`, Value: this.props.location.state.selection }],
            QualScope: null,
            //NEW STATE VARIABLE THAT MANAGES THE POPUP FLAG
            linkDialogUSOpen: false,
            selectedRowID: null
        };
    }

    handleLowerToolbarButtonClick(buttonId) {
        if ("next" === buttonId) {
            this.props.history.push({
                pathname: '/OnlineAssessorApprovalUnitStandardScope',
                state: {
                    selection: this.props.location.state.selection,
                    QualScopeSelection: this.state.QualScope
                }
            });
        } else if ("back" === buttonId) {
            this.props.history.push({
                pathname: '/assessorapproval',
                state: {
                    selection: this.props.location.state.selection
                }
            });
        }
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ QualScope: selection });
            if (selection.length === 1) {
                this.setState({ selectedRowID: selection[0].QualificationID });
                linkToolbarRef.current.setButtonDisabled("viewScopeUS", false);
            }
            else {
                linkToolbarRef.current.setButtonDisabled("viewScopeUS", true);
            }
        } else {
            this.setState({ QualScope: null, selectedRowID: null });
            linkToolbarRef.current.setButtonDisabled("viewScopeUS", true);
        }
    };

    handleTopToolbarButtonClick = (buttonId) => {
        if (buttonId === "viewScopeUS") {
            this.setState({ linkDialogUSOpen: true })
        }
    };

    closeUSScope(isCancel, linked) {
        this.setState({ linkDialogUSOpen: false })
    }

    render() {
        return (
            <ViewContainer title="">
                <p className="breadcrumbs">
                    {"Assessor Approval > Qualification Scope"}
                </p>

                <EnhancedToolbar
                    highlight={false}
                    ref={linkToolbarRef}
                    buttonClickHandler={(buttonId) => this.handleTopToolbarButtonClick(buttonId)}
                    config={topToolbarConfig}
                />

                <br />

                <EnhancedTable
                    multiSelect={true}
                    autoFetchData={true}
                    headCells={headCells}
                    searchParameters={this.state.searchParameters}
                    paged={false}
                    dataUrl="api/sims/OnlineAssessorApproval/GetQualificationScope"
                    onSelectionChange={this.handleSelectionChange}
                />
                <LinkDialog open={this.state.linkDialogUSOpen} closeHandler={(isCancelled, linked) => this.closeUSScope(isCancelled, linked)}
                    dialogTitle={`Unit standards linked to Qualification`}
                >
                    <OnlineAssessorScopeUS IsExternal={this.props.IsExternal} ScopeType="Q" dataUrl="api/sims/OnlineAssessorRegistration/GetSearchScopeInterventionUS"
                        Id={this.state.selectedRowID} />
                </LinkDialog>

                <table width="100%">
                    <tbody>
                        <tr>
                            <td width="90%"></td>
                            <td width="20%" align="right">
                                <div style={{ width: "120px", marginTop: "16px" }}>
                                    <EnhancedToolbar
                                        highlight={false}
                                        title=""
                                        buttonClickHandler={(buttonId) => this.handleLowerToolbarButtonClick(buttonId)}
                                        config={lowertoolbarConfig}
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ViewContainer>
        );
    }
}

export default withRouter(withMenuPermission(OnlineAssessorApprovalQualificationScope));
